import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
const LinkButton = ({
  children,
  to,
  isLarge = false,
  className
}) => {
  const linkClassNames = classNames(`${className ?? ''}`, 'block', 'bg-kira-blue-300', 'hover:bg-kira-blue-500', 'text-white', 'px-12', 'py-3.5', 'font-bold', 'rounded-full', `${isLarge ? 'text-xl' : 'text-lg'}`);
  return /*#__PURE__*/React.createElement(Link, {
    to: to,
    className: linkClassNames
  }, children);
};
export default LinkButton;